export default "__VITE_ASSET__rORjKk6o__"